import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { Language, Portal } from '@mobi/mcs-schadenmeldung-types-ng-jslib';

import { PORTAL_SEGMENT } from '../../../shared/constants/portal.constants';
import * as fromCore from '../../../state/actions/core.actions';

import { selectHeaderView } from './header.component.selectors';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderComponent {
    private store = inject(Store);
    private readonly router = inject(Router);

    view$ = this.store.select(selectHeaderView);

    logout() {
        this.store.dispatch(fromCore.logoutFromHeader());
    }

    login() {
        this.store.dispatch(fromCore.loginFromHeader());
    }

    handleLogoClick(language: Language, portal: Portal) {
        return this.router.navigate([`/${PORTAL_SEGMENT[portal]}-${language}`]);
    }
}
